module.exports = __webpack_public_path__ + "img/story028@2x.e9579451.webp";